import { render, staticRenderFns } from "./WorkNotificationTrackerIcon.vue?vue&type=template&id=6091e5d0"
import script from "./WorkNotificationTrackerIcon.vue?vue&type=script&lang=js"
export * from "./WorkNotificationTrackerIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports